/*** Utilities ***/
export function buildSlots(startHour, endHour, slotMinutes) {
  const out = [];
  const total = (endHour - startHour) * 60;
  const steps = Math.ceil(total / slotMinutes);
  for (let i = 0; i < steps; i++) {
    const minutesFromStart = i * slotMinutes;
    const hour = Math.floor(minutesFromStart / 60) + startHour;
    const minute = minutesFromStart % 60;
    out.push({ hour, minute, minutesFromStart, onHour: minute === 0 });
  }
  return out;
}
export function overlaps(a, b) {
  return !(a.end <= b.start || b.end <= a.start);
}
export function ymd(d) {
  return (typeof d === "string" ? d : d.toISOString()).slice(0, 10);
}
export function pad(n) {
  return String(n).padStart(2, "0");
}
export function fmtHM(mins) {
  const h = Math.floor(mins / 60),
    m = mins % 60;
  return `${pad(h)}:${pad(m)}`;
}
export function minToHrs(mins) {
  const h = Math.floor(mins / 60); // hours
  const m = mins % 60; // minutes
  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = ((h + 11) % 12) + 1; // convert to 12-hour clock
  return `${hour12}:${pad(m)} ${suffix}`;
}
export function minsToTime(mins) {
  return fmtHM(mins);
}
export function timeToMins(s) {
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
}
export function formatLong(d) {
  const date = d instanceof Date ? d : new Date(d);
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
export function cryptoId() {
  return Math.random().toString(36).slice(2, 9);
}
export function withIds(arr) {
  return arr.map((x) => ({ id: x.id || cryptoId(), ...x }));
}
export function pickColour(seed) {
  const palette = [
    "#3b82f6",
    "#10b981",
    "#f59e0b",
    "#ef4444",
    "#8b5cf6",
    "#14b8a6",
    "#e11d48",
  ];
  const i = Math.abs(hash(seed)) % palette.length;
  return palette[i];
}
export function hash(str = "") {
  let h = 0;
  for (const ch of str) {
    h = (h << 5) - h + ch.charCodeAt(0);
    h |= 0; // force 32-bit
  }
  return h;
}
export function defaultTables(n) {
  return Array.from({ length: n }, (_, i) => ({
    id: i + 1,
    name: `Table ${i + 1}`,
  }));
}
export function groupBy(arr, key) {
  return arr.reduce((m, x) => {
    (m[x[key]] ||= []).push(x);
    return m;
  }, {});
}
